import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "el-picker-panel__body-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "el-picker-panel__sidebar"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "el-picker-panel__body" }
const _hoisted_5 = {
  key: 0,
  class: "el-date-range-picker__time-header"
}
const _hoisted_6 = { class: "el-date-range-picker__editors-wrap" }
const _hoisted_7 = { class: "el-date-range-picker__time-picker-wrap" }
const _hoisted_8 = { class: "el-date-range-picker__time-picker-wrap" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "el-icon-arrow-right" }, null, -1)
const _hoisted_10 = { class: "el-date-range-picker__editors-wrap is-right" }
const _hoisted_11 = { class: "el-date-range-picker__time-picker-wrap" }
const _hoisted_12 = { class: "el-date-range-picker__time-picker-wrap" }
const _hoisted_13 = { class: "el-picker-panel__content el-date-range-picker__content is-left" }
const _hoisted_14 = { class: "el-date-range-picker__header" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "el-picker-panel__content el-date-range-picker__content is-right" }
const _hoisted_18 = { class: "el-date-range-picker__header" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 0,
  class: "el-picker-panel__footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_time_pick_panel = _resolveComponent("time-pick-panel")!
  const _component_date_table = _resolveComponent("date-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_clickoutside = _resolveDirective("clickoutside")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["el-picker-panel el-date-range-picker", [{
      'has-sidebar': _ctx.$slots.sidebar || _ctx.hasShortcuts,
      'has-time': _ctx.showTime
    }]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "sidebar", { class: "el-picker-panel__sidebar" }),
      (_ctx.hasShortcuts)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shortcuts, (shortcut, key) => {
              return (_openBlock(), _createElementBlock("button", {
                key: key,
                type: "button",
                class: "el-picker-panel__shortcut",
                onClick: ($event: any) => (_ctx.handleShortcutClick(shortcut))
              }, _toDisplayString(shortcut.text), 9, _hoisted_3))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.showTime)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, [
                  _createVNode(_component_el_input, {
                    size: "small",
                    disabled: _ctx.rangeState.selecting,
                    placeholder: _ctx.t('Controls.DatePicker.StartDate'),
                    class: "el-date-range-picker__editor",
                    "model-value": _ctx.minVisibleDate,
                    onInput: _cache[0] || (_cache[0] = val => _ctx.handleDateInput(val, 'min')),
                    onChange: _cache[1] || (_cache[1] = val => _ctx.handleDateChange(val, 'min'))
                  }, null, 8, ["disabled", "placeholder", "model-value"])
                ]),
                _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_8, [
                  _createVNode(_component_el_input, {
                    size: "small",
                    class: "el-date-range-picker__editor",
                    disabled: _ctx.rangeState.selecting,
                    placeholder: _ctx.t('Controls.DatePicker.StartTime'),
                    "model-value": _ctx.minVisibleTime,
                    onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.minTimePickerVisible = true)),
                    onInput: _cache[3] || (_cache[3] = val => _ctx.handleTimeInput(val, 'min')),
                    onChange: _cache[4] || (_cache[4] = val => _ctx.handleTimeChange(val, 'min'))
                  }, null, 8, ["disabled", "placeholder", "model-value"]),
                  _createVNode(_component_time_pick_panel, {
                    visible: _ctx.minTimePickerVisible,
                    format: _ctx.timeFormat,
                    "datetime-role": "start",
                    "time-arrow-control": _ctx.arrowControl,
                    "parsed-value": _ctx.leftDate,
                    onPick: _ctx.handleMinTimePick
                  }, null, 8, ["visible", "format", "time-arrow-control", "parsed-value", "onPick"])
                ])), [
                  [_directive_clickoutside, _ctx.handleMinTimeClose]
                ])
              ]),
              _hoisted_9,
              _createElementVNode("span", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, [
                  _createVNode(_component_el_input, {
                    size: "small",
                    class: "el-date-range-picker__editor",
                    disabled: _ctx.rangeState.selecting,
                    placeholder: _ctx.t('Controls.DatePicker.EndDate'),
                    "model-value": _ctx.maxVisibleDate,
                    readonly: !_ctx.minDate,
                    onInput: _cache[5] || (_cache[5] = val => _ctx.handleDateInput(val, 'max')),
                    onChange: _cache[6] || (_cache[6] = val => _ctx.handleDateChange(val, 'max'))
                  }, null, 8, ["disabled", "placeholder", "model-value", "readonly"])
                ]),
                _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_12, [
                  _createVNode(_component_el_input, {
                    size: "small",
                    class: "el-date-range-picker__editor",
                    disabled: _ctx.rangeState.selecting,
                    placeholder: _ctx.t('Controls.DatePicker.EndTime'),
                    "model-value": _ctx.maxVisibleTime,
                    readonly: !_ctx.minDate,
                    onFocus: _cache[7] || (_cache[7] = ($event: any) => (_ctx.minDate && (_ctx.maxTimePickerVisible = true))),
                    onInput: _cache[8] || (_cache[8] = val => _ctx.handleTimeInput(val, 'max')),
                    onChange: _cache[9] || (_cache[9] = val => _ctx.handleTimeChange(val, 'max'))
                  }, null, 8, ["disabled", "placeholder", "model-value", "readonly"]),
                  _createVNode(_component_time_pick_panel, {
                    "datetime-role": "end",
                    visible: _ctx.maxTimePickerVisible,
                    format: _ctx.timeFormat,
                    "time-arrow-control": _ctx.arrowControl,
                    "parsed-value": _ctx.rightDate,
                    onPick: _ctx.handleMaxTimePick
                  }, null, 8, ["visible", "format", "time-arrow-control", "parsed-value", "onPick"])
                ])), [
                  [_directive_clickoutside, _ctx.handleMaxTimeClose]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              type: "button",
              class: "el-picker-panel__icon-btn el-icon-d-arrow-left",
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.leftPrevYear && _ctx.leftPrevYear(...args)))
            }),
            _createElementVNode("button", {
              type: "button",
              class: "el-picker-panel__icon-btn el-icon-arrow-left",
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.leftPrevMonth && _ctx.leftPrevMonth(...args)))
            }),
            (_ctx.unlinkPanels)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  disabled: !_ctx.enableYearArrow,
                  class: _normalizeClass([{ 'is-disabled': !_ctx.enableYearArrow }, "el-picker-panel__icon-btn el-icon-d-arrow-right"]),
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.leftNextYear && _ctx.leftNextYear(...args)))
                }, null, 10, _hoisted_15))
              : _createCommentVNode("", true),
            (_ctx.unlinkPanels)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  disabled: !_ctx.enableMonthArrow,
                  class: _normalizeClass([{ 'is-disabled': !_ctx.enableMonthArrow }, "el-picker-panel__icon-btn el-icon-arrow-right"]),
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.leftNextMonth && _ctx.leftNextMonth(...args)))
                }, null, 10, _hoisted_16))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, _toDisplayString(_ctx.leftLabel), 1)
          ]),
          _createVNode(_component_date_table, {
            "selection-mode": "range",
            date: _ctx.leftDate,
            "min-date": _ctx.minDate,
            "max-date": _ctx.maxDate,
            "range-state": _ctx.rangeState,
            "disabled-date": _ctx.disabledDate,
            "cell-class-name": _ctx.cellClassName,
            onChangerange: _ctx.handleChangeRange,
            onPick: _ctx.handleRangePick,
            onSelect: _ctx.onSelect
          }, null, 8, ["date", "min-date", "max-date", "range-state", "disabled-date", "cell-class-name", "onChangerange", "onPick", "onSelect"])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            (_ctx.unlinkPanels)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  disabled: !_ctx.enableYearArrow,
                  class: _normalizeClass([{ 'is-disabled': !_ctx.enableYearArrow }, "el-picker-panel__icon-btn el-icon-d-arrow-left"]),
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.rightPrevYear && _ctx.rightPrevYear(...args)))
                }, null, 10, _hoisted_19))
              : _createCommentVNode("", true),
            (_ctx.unlinkPanels)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  disabled: !_ctx.enableMonthArrow,
                  class: _normalizeClass([{ 'is-disabled': !_ctx.enableMonthArrow }, "el-picker-panel__icon-btn el-icon-arrow-left"]),
                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.rightPrevMonth && _ctx.rightPrevMonth(...args)))
                }, null, 10, _hoisted_20))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "el-picker-panel__icon-btn el-icon-d-arrow-right",
              onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.rightNextYear && _ctx.rightNextYear(...args)))
            }),
            _createElementVNode("button", {
              type: "button",
              class: "el-picker-panel__icon-btn el-icon-arrow-right",
              onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.rightNextMonth && _ctx.rightNextMonth(...args)))
            }),
            _createElementVNode("div", null, _toDisplayString(_ctx.rightLabel), 1)
          ]),
          _createVNode(_component_date_table, {
            "selection-mode": "range",
            date: _ctx.rightDate,
            "min-date": _ctx.minDate,
            "max-date": _ctx.maxDate,
            "range-state": _ctx.rangeState,
            "disabled-date": _ctx.disabledDate,
            "cell-class-name": _ctx.cellClassName,
            onChangerange: _ctx.handleChangeRange,
            onPick: _ctx.handleRangePick,
            onSelect: _ctx.onSelect
          }, null, 8, ["date", "min-date", "max-date", "range-state", "disabled-date", "cell-class-name", "onChangerange", "onPick", "onSelect"])
        ])
      ])
    ]),
    (_ctx.showTime)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createVNode(_component_el_button, {
            size: "mini",
            type: "text",
            class: "el-picker-panel__link-btn",
            onClick: _ctx.handleClear
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('Controls.DatePicker.Clear')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            plain: "",
            size: "mini",
            class: "el-picker-panel__link-btn",
            disabled: _ctx.btnDisabled,
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.handleConfirm(false)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('Controls.DatePicker.Confirm')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}